<template>
	<div class="container contact-guide">
		<div class="title">
			<div class="back-btn" @click="goBack()">
				<i class="fa fa-arrow-left"></i>
			</div>
			<h1>How to Track Your Technician</h1>
		</div>
		<div class="row">
			<div class="col-md-10 offset-md-1 col-lg-8 offset-lg-2">
				<div class="faq-question">
					<h3 class="question">Option 1</h3>
					<p class="answer">
						On the day of your repair, you’ll receive an email with your timeslot. Click the "Track my technician" button. You’ll be taken to the technician tracking page. From here, you can see the technician’s current location, along with the estimated time of arrival.
					</p>
					<p class="answer">
						<strong>Haven't received this email yet?</strong> It will be sent at 18:00 on the evening before your repair.
					</p>
				</div>
				<div class="faq-question">
					<h3 class="question">Option 2</h3>
					<p class="answer">
						On the day of your repair, head to the "<a href="/manage" target="_blank">Manage booking</a>" page. Select the "Track technician" tab, enter your email address and order reference and click the "Track technician" button. You’ll be taken to the technician tracking page. From here, you can see the technician’s current location, along with the estimated time of arrival.
					</p>
				</div>
			</div>
			<div class="col-lg-10 offset-lg-1">
				<div class="d-flex mt-5">
					<button class="btn btn-outline-secondary mx-auto" @click="showContactForms">This didnt solve my issue</button>
				</div>
			</div>
		</div>
	</div>
</template>

<script>
export default {
	methods: {
		goBack() {
			this.$emit('clearSelection');
		},

		showContactForms() {
			this.$emit('showContactForms');
		}
	}
}
</script>

<style scoped>

</style>